import { useState } from "react";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import CountDownTimer from "./CountDownTimer";
import Collapse from "@mui/material/Collapse";
import DoneIcon from "@mui/icons-material/Done";
import ChallengeWorkout from "./ChallengeWorkout";
import ClearIcon from "@mui/icons-material/Clear";
import { FormButton } from "../../data/style/Style";
import { MainText, SpacedRow } from "../../data/style/Style";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Challenge = ({
  image_url,
  challenger,
  challenge_id,
  expires,
  workout_id,
  pending,
}) => {
  const [challengeId, setChallengeId] = useState(0);

  return (
    <Stack>
      <SpacedRow
        alignItems={"center"}
        p={1}
        gap={1}
        borderBottom={"1px solid white"}
      >
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <Avatar
            src={process.env.REACT_APP_BACKEND_DOMAIN + "/media/" + image_url}
          />
          <MainText>{challenger}</MainText>
        </Stack>
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <CountDownTimer targetTimestamp={expires} />
          {challengeId === challenge_id ? (
            <KeyboardArrowUpIcon
              onClick={() => setChallengeId(0)}
              sx={{ color: "white" }}
            />
          ) : (
            <KeyboardArrowDownIcon
              onClick={() => setChallengeId(challenge_id)}
              sx={{ color: "white" }}
            />
          )}
        </Stack>
      </SpacedRow>
      <Collapse timeout={1000} in={challengeId === challenge_id}>
        <Stack gap={1} p={1}>
          <ChallengeWorkout wodId={workout_id} />
          {pending && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"end"}
              gap={1}
            >
              <FormButton tooltip={"Accept"} icon={<DoneIcon />} />
              <FormButton alt={false} tooltip={"Reject"} icon={<ClearIcon />} />
            </Stack>
          )}
        </Stack>
      </Collapse>
    </Stack>
  );
};

export default Challenge;
